import { render, staticRenderFns } from "./SuccessInscription.vue?vue&type=template&id=371cd7be&scoped=true"
import script from "./SuccessInscription.vue?vue&type=script&lang=js"
export * from "./SuccessInscription.vue?vue&type=script&lang=js"
import style0 from "./SuccessInscription.vue?vue&type=style&index=0&id=371cd7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371cd7be",
  null
  
)

export default component.exports